import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Label } from 'reactstrap';
import {
  arrayToFormattedString,
  checkNullValue,
  getBlankValueIfNUll,
  stringToFormattedString,
} from '../utils/Util';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';
import CandidateNameEdit from './CandidateNameEdit';
import { loginSelector } from '../features/loginSlice';
import { LoggedUserType } from '../utils/Types';
import { useAppDispatch, useAppSelector } from '../store/redux-hooks';
import Chip from '@mui/material/Chip';
import AlertPopUP from '../pages/modals/AlertPopUp';
import { alertPopupToggle, onRemove } from './BasicDetailsHelper';
interface IBasicDetailsProps {
  user?: any;
  campaignDetail?: any;
  assignedgrids?: string;
  employeeKeyShow?: boolean;
  documentDetails?: any;
  isEditable?: boolean;
  refreshData?: () => void;
  setShowLoader?: (isLoading: boolean) => void;
}

const BasicDetails: React.FunctionComponent<IBasicDetailsProps> = ({
  user,
  campaignDetail,
  assignedgrids,
  employeeKeyShow = false,
  documentDetails,
  isEditable = false,
  refreshData = () => {},
  setShowLoader = () => {},
}) => {
  const [enableEdit, setEnableEdit] = React.useState<boolean>(false);
  const loggedUser: LoggedUserType = useAppSelector(loginSelector).user;
  const onHandleEdit = () => {
    setEnableEdit(true);
  };
  const [showAlertPopUp, setShowAlertPopUp] = React.useState<boolean>(false);
  const [removeGridId, setRemoveGridId] = React.useState<any>();
  const dispatch = useAppDispatch();
  const getProfileDetails = () => (
    <div className="mt-4 mb-2 pb-2 mx-4">
      {documentDetails ? (
        <Row>
          {documentDetails?.documentId === 1 && (
            <Col xs={12} md={4}>
              <Label className="mb-0 model-label-name">Aadhar No</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {checkNullValue(documentDetails.aadharNo)}
              </Label>
            </Col>
          )}
          {documentDetails?.documentId === 2 && (
            <Col xs={12} md={4}>
              <Label className="mb-0 model-label-name">
                Education qualification
              </Label>
              <br />
              <Label className="mb-0 model-label-value">
                {checkNullValue(documentDetails.educationQualification)}
              </Label>
            </Col>
          )}
          {documentDetails?.documentId === 4 && (
            <Col xs={12} md={4}>
              <Label className="mb-0 model-label-name">PAN No</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {checkNullValue(documentDetails.panNo)}
              </Label>
            </Col>
          )}
          {documentDetails?.documentId === 3 && (
            <Row>
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">Bank Name</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {checkNullValue(documentDetails.bankName)}
                </Label>
              </Col>
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">
                  Account Holder Name
                </Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {checkNullValue(documentDetails.accountHolderName)}
                </Label>
              </Col>
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">Account Number</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {checkNullValue(documentDetails.accountNumber)}
                </Label>
              </Col>
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">IFSC Code</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {checkNullValue(documentDetails.ifsccode)}
                </Label>
              </Col>
            </Row>
          )}
        </Row>
      ) : (
        <>
          <Row>
            {employeeKeyShow ? (
              <>
                <Col xs={12} md={4}>
                  <Label className="mb-0 model-label-name">Employee Id</Label>
                  <br />
                  <Label className="mb-0 model-label-value">
                    {checkNullValue(user?.employeeUniqueId)}
                  </Label>
                </Col>
                <Col xs={12} md={4}>
                  <Label className="mb-0 model-label-name">Employee Name</Label>
                  <br />
                  <Label className="mb-0 model-label-value">{`${getBlankValueIfNUll(
                    user?.firstName || user?.fullname || user?.fullName
                  )} ${getBlankValueIfNUll(user?.lastName)}`}</Label>
                </Col>
              </>
            ) : (
              <>
                <Col xs={12} md={4}>
                  <Label className="mb-0 model-label-name">Candidate Id</Label>
                  <br />
                  <Label className="mb-0 model-label-value">
                    {checkNullValue(user?.candidateuniqueid)}
                  </Label>
                </Col>
                <Col xs={12} md={4}>
                  <Label className="mb-0 model-label-name">
                    Candidate Name
                  </Label>
                  {(loggedUser?.roleId === 15 || loggedUser?.roleId === 41) &&
                  isEditable ? (
                    <IconButton aria-label="edit">
                      <EditIcon
                        sx={{ fontSize: 14, color: 'black' }}
                        onClick={onHandleEdit}
                      />
                    </IconButton>
                  ) : null}
                  <br />
                  {enableEdit ? (
                    <CandidateNameEdit
                      user={{
                        firstname: user?.firstname,
                        lastname: user?.lastname,
                      }}
                      candidateId={user?.candidateid}
                      loggedCandidateID={loggedUser?.candidateId}
                      setEnableEditValue={(data: any) => setEnableEdit(data)}
                      refreshData={refreshData}
                      setShowLoader={setShowLoader}
                    />
                  ) : (
                    <Label className="mb-0 model-label-value">{`${getBlankValueIfNUll(
                      user?.firstname
                    )} ${getBlankValueIfNUll(user?.lastname)}`}</Label>
                  )}
                </Col>
              </>
            )}
            <Col xs={12} md={4}>
              <Label className="mb-0 model-label-name">Role</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {checkNullValue(user?.rolename || user?.roleName)}
              </Label>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col xs={12} md={4}>
              <Label className="mb-0 model-label-name">Mobile Number</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {checkNullValue(user?.mobilenumber || user?.mobileNumber)}
              </Label>
            </Col>
            <Col xs={12} md={4}>
              <Label className="mb-0 model-label-name">Email</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {checkNullValue(user?.emailid || user?.emailId)}
              </Label>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col xs={12} md={4} style={{ minWidth: 0 }}>
              <Label className="mb-0 model-label-name">Address</Label>
              <br />
              <Label
                className="mb-0 model-label-value"
                style={{
                  whiteSpace: 'normal',
                  overflowWrap: 'anywhere',
                  wordBreak: 'break-word',
                }}
              >
                {checkNullValue(user?.address)}
              </Label>
            </Col>
            <Col xs={12} md={4}>
              <Label className="mb-0 model-label-name">Pincode</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {checkNullValue(user?.pincode)}
              </Label>
            </Col>
            <Col xs={12} md={4}>
              <Label className="mb-0 model-label-name">Zone</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {checkNullValue(user?.zonename || user?.zoneName)}
              </Label>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col xs={12} md={4}>
              <Label className="mb-0 model-label-name">State</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {checkNullValue(user?.statename || user?.stateName)}
              </Label>
            </Col>
            <Col xs={12} md={4}>
              <Label className="mb-0 model-label-name">District</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {checkNullValue(user?.districtName ?? user?.districtName)}
              </Label>
            </Col>
            <Col xs={12} md={4}>
              <Label className="mb-0 model-label-name">City/Village</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {checkNullValue(user?.cityname ?? user?.cityName)}
              </Label>
            </Col>
          </Row>
          {campaignDetail && (
            <Row className="mt-4">
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">
                  How do you hear about us?
                </Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {arrayToFormattedString(campaignDetail?.campaignName)}
                </Label>
              </Col>
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">
                  Referral Name & Mobile Number
                </Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {stringToFormattedString(campaignDetail?.referralName)}
                </Label>
              </Col>
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">Other</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {stringToFormattedString(campaignDetail.othersDes)}
                </Label>
              </Col>
            </Row>
          )}
          {assignedgrids && (
            <Row className="mt-4">
              <Col xs={12} md={6}>
                <Label className="mb-0 model-label-name">Assigned Grids</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {assignedgrids &&
                    assignedgrids.split(',').map((item: any) => {
                      return (
                        <Chip
                          key={item}
                          label={item}
                          onDelete={() =>
                            onRemove(item, setShowAlertPopUp, setRemoveGridId)
                          }
                          style={{
                            margin: 4,
                            padding: '0 10px',
                            backgroundColor: '#d4edda',
                            borderColor: '#c3e6cb',
                            color: '#155724',
                            borderRadius: 20,
                            borderWidth: 1,
                            borderStyle: 'solid',
                          }}
                        />
                      );
                    })}
                  {showAlertPopUp && (
                    <AlertPopUP
                      isOpen={showAlertPopUp}
                      toggle={(action: string) => {
                        alertPopupToggle(
                          action,
                          removeGridId,
                          dispatch,
                          setShowAlertPopUp,
                          setRemoveGridId,
                          user?.candidateid,
                          loggedUser?.candidateId,
                          refreshData,
                          setShowLoader
                        );
                      }}
                    />
                  )}
                </Label>
              </Col>
            </Row>
          )}
        </>
      )}
    </div>
  );
  return getProfileDetails();
};

export default BasicDetails;
